module.exports = __webpack_public_path__ + "static/media/blackbox-logo.0fbbd8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/blackbox-logo.png
// module id = 1178
// module chunks = 0